import React from "react";

import { useSprintFetch } from "../../data-access/useSprintFetch";
import { defaultFeatureFlags, FeatureFlags, FeatureFlagsContext } from "./FeatureFlagsContext";

export const FeatureFlagsProvider: React.FC = (props: React.PropsWithChildren<unknown>) => {
    const [featureFlags, setFeatureFlags] = React.useState<FeatureFlags>(defaultFeatureFlags);
    const [isLoading, setIsLoading] = React.useState(false);
    const sprintFetch = useSprintFetch({ isPublic: false });

    React.useEffect(() => {
        setIsLoading(true);
        sprintFetch.httpGet<FeatureFlags>(`${process.env.PUBLIC_URL}/feature-flags`).then((configJson) => {
            setFeatureFlags(configJson);
            setIsLoading(false);
        });
    }, []);

    return (
        <FeatureFlagsContext.Provider value={{ featureFlags, isLoading }}>
            {props.children}
        </FeatureFlagsContext.Provider>
    );
};
